<template>
    <div>
        <b-modal
            :id="modalId"
            @hidden="onModalHidden()"
            modal-class="modal-copy-personal"
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-base">
                <div class="modal-base-body">
                    <div class="page-wrapper">
                        <div class="page-bg"></div>
                        <div class="page-content">
                            <TopBarDark
                                :title="lbl.profile.copy_personal_modal.title_topbar"
                                @clickBack="clickBack()">
                            </TopBarDark>
                            <div class="copy-personal-page">
                                <div class="text-copy-personal">
                                    <div class="text-title">{{info.firstname}}</div>
                                    <div class="text-detail">{{profile.firstName}}</div>
                                </div>
                                <div class="text-copy-personal">
                                    <div class="text-title">{{info.lastname}}</div>
                                    <div class="text-detail">{{profile.lastName}}</div>
                                </div>
                                <div class="text-copy-personal">
                                    <div class="text-title">{{info.birthdate}}</div>
                                    <div class="text-detail">{{birthdate}}</div>
                                </div>
                                <div class="text-copy-personal">
                                    <div class="text-title">{{info.contact_number}}</div>
                                    <div class="text-detail">{{profile.contactNumber}}</div>
                                </div>
                                <div class="text-copy-personal">
                                    <div class="text-title">{{info.age}}</div>
                                    <div class="text-detail">{{info.consent_age}}</div>
                                </div>
                                <div class="input-area">
                                    <div class="title-email">{{info.title_email}}</div>
                                    <div>
                                        <Email
                                            inputId="email"
                                            :inputLbl="info.email"
                                            :isFirstSave="isFirstSave"
                                            :isShowErrorLbl="isShowErrorLbl"
                                            :errorInfo="errorInfo[0]"
                                            :copyPersonal="true"
                                            :inputMaxLength="60"
                                            v-model="formData.email"
                                            @input="onEmailChange($event)"/>
                                    </div>
                                </div>
                                <div class="text-copy-personal">
                                    <div class="text-detail">
                                        <div class="text-title">{{info.pin}}</div>
                                        <div>
                                        <div class="box-pin">
                                            <label for="input-pin">
                                                <div class="d-flex justify-content-center">
                                                    <div class="box-input-pin">{{formData.pin[0]}}</div>
                                                    <div class="box-input-pin">{{formData.pin[1]}}</div>
                                                    <div class="box-input-pin">{{formData.pin[2]}}</div>
                                                    <div class="box-input-pin">{{formData.pin[3]}}</div>
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                    <input  type="tel"
                                            id="input-pin"
                                            class="input-pin-dummy"
                                            maxlength="4"
                                            v-model="formData.pin"
                                            @input="onPinChange()"
                                            @blur="onPinBlur()">
                                    </div>
                                </div>
                                <div class="btn-accept" v-if="isValid"  @click="clickOk()">
                                    <div class="btn-txt">
                                        {{info.btn}}
                                    </div>
                                </div>
                                <div class="btn-accept disabled" v-else>
                                    <div class="btn-txt">
                                        {{info.btn}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-base-footer">

                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import FormHelper from '@/helper/FormHelper.js';
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
//component
import TopBarDark from "@/components/Layout/TopBarPage/TopBarDark.vue";
import DatetimeHelper from '@/helper/DatetimeHelper.js';
import Email from '@/components/Input/Email.vue'
//service
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";
/**
 * @property {CopyPersonalModalController} controller (required)../Controller/ProductDescriptionModalController.js
 * @property {String} modalId (reqquired)
 */

export default {
    name: "CopyPersonalModal",
    props: {
        controller: Object,
        modalId: String,
        loadingModal: Object, //loding modal from master controller
    },
    components: {
        TopBarDark,
        Email,
    },
    mixins: [AccountMixin, LocaleMixin, ErrorApiMixin],
    data: function() {
        return {
            title: "",
            message: "",
            btnOk: "",
            tag: "",
            busModal: null,
            info: "",
            profile: {},
            birthdate: null,
            errorInfo: [],
            isShowErrorLbl: true,
            isFirstSave: true,
            formData: {
                email: '',
                pin: '',
            },
            isValid: false
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
        this.info = this.lbl.profile.copy_personal_modal;
        this.errorInfo = FormHelper.genErrorInfo(1);
    },
    mounted: function() {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function() {
            this.onOk();
        },
        clickBack: function(){
            this.hide();
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.tag = config.tag;
            this.profile = config.profile || {};
            this.birthdate = this.profile.birthDate ? DatetimeHelper.dateFullFormatNoUtc(this.profile.birthDate): '-';

            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            this.validateData();
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.formData.email = '';
            this.formData.pin = '';
            this.$bvModal.hide(this.modalId);
        },
        onOk: function () {
            var isEmailValid = this.validateEmail();
            if (isEmailValid) {
                this.submitCopyPersonal();
                this.hide();
            }
        },
        onEmailChange : function(email) {
            this.formData.email = email;
            this.validateData();
        },
        onPinChange: function() {
            this.formData.pin = this.formData.pin.replace(/\D/g, '');
            this.errorText = '';

            if(Util.getMobileOS() == 'iOS'){
                var element = document.getElementById(this.modalId);
                element.firstElementChild.classList.add("ios");
            }
            this.validateData();
        },
        validateData: function() {
            if (this.formData.email && this.formData.pin.length == 4) {
                this.isValid = true;
            } else {
                this.isValid = false;
            }
        },
        validateEmail: function(){
            if(this.formData.email){
                if(!this.errorInfo[0].isValid) return false;
                else return true;
            }else{
                return true;
            }
        },
        onPinBlur: function(){
            if(Util.getMobileOS() == 'iOS'){
                var element = document.getElementById(this.modalId);
                element.firstElementChild.classList.remove("ios");
            }
        },
        submitCopyPersonal: function () {
            var token = this.getToken();
            var params = {
                email: this.formData.email,
                pin: this.formData.pin
            }
            this.controller.loadingModal.show();
            return new Promise((resolve, reject) => {
                BzbsProfile.apiPostCopyPersonal(token,params).subscribe((data) => {
                    resolve(data);
                    this.controller.loadingModal.hide();
                    this.controller.alertModal.clearText()
                                            .setTitle(this.lbl.profile.alert_title)
                                            .setMsg(this.lbl.profile.alert_msg)
                                            .setBtnOk(this.lbl.profile.alert_btn)
                                            .setTheme('gray')
                                            .show()
                }, (err) => {
                    reject(err);
                    this.controller.loadingModal.hide();
                });
            });
        },
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseText.scss";
@import "@/style/base/baseDisplay.scss";
@import '@/style/input/BaseButton.scss';
.modal-copy-personal{
    .page-wrapper {
        .page-bg {
            background-color: $white;
        }
    }
    .copy-personal-page {
        @include bg-curve();
        position: absolute;
        bottom: unset;
        padding: 30px 25px 10px;
        word-wrap: break-word;

        .text-copy-personal {
            font-size: 1.25rem;
            line-height: 1.56;
            text-align: left;
            line-height: 1.56;
            margin: 15px 37px 20px 32px;

            .text-title {
                color: $bright-gray;
            }
            .text-detail {
                color: $black;

                @include mini-mobile(){
                    font-size: 0.9rem;
                }
                .box-pin {
                    text-align: left;
                }
                .box-input-pin {
                    width: 40px;
                    height: 53px;
                    border: solid 1px $border-gray;
                    background-color: $white;
                    border-radius: 5px;
                    margin: 3px 3px 10px;
                    padding-top: 8px;
                    font-size: 1.6rem;
                    text-align: center;

                }
                .input-pin-dummy {
                    position: absolute;
                    // top: -20000px;
                    left: -20000px;
                    opacity: 0;
                }
            }
        }
        .input-area {
            margin: 15px 0 25px 25px;
            font-size: 1.25rem;
            color: $bright-gray;

            .title-email {
                margin-left: 8px;
                margin-bottom: -3.75rem;
            }
        }
        .title-msg {
            font-size: 1.125rem;
            color: $black;
            text-align: center;
            margin: {
                top: 20px;
                bottom: 30px;
            }
        }
        .btn-accept{
            @include btn-wrapper();
            margin: 15px auto 20px;

            &:disabled {
                opacity: 0.3;
            }

            @include mini-mobile(){
                min-height: 40px;
            }

        }
    }
}

</style>

<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/modal.scss";
.modal-copy-personal{
    .modal-dialog{
        margin: 0;

        .modal-content{
            border: 0;

            .modal-body{
                padding: 0;
            }
        }
    }
}
</style>
